<script setup lang="ts">
type Props = {
  seoContent?: string
}

const props = withDefaults(defineProps<Props>(), {
  seoContent: '',
})

const isVisibleText = ref(false)

const buttonText = computed(() => {
  return isVisibleText.value ? 'Скрыть' : 'Показать текст'
})

const isVisibleButton = computed(() => props.seoContent.length >= 200)

const toggleVisibleText = () => {
  isVisibleText.value = !isVisibleText.value
}
</script>

<template>
  <div class="seo-description">
    <div class="seo" :class="{ 'seo--hidden': !isVisibleText }">
      <div
        v-if="props.seoContent"
        class="seo__content"
        v-html="props.seoContent"
      />
    </div>

    <div v-if="!isVisibleText" class="seo-description__gradient" />

    <the-button
      v-if="isVisibleButton"
      class="seo-description__button"
      :class="{ 'seo-description__button--hidden': isVisibleText }"
      variant="tertiary"
      @click="toggleVisibleText"
    >
      <the-icon class="seo-description__icon" name="expand-down" />

      {{ buttonText }}
    </the-button>
  </div>
</template>

<style lang="scss" scoped>
.seo-description {
  position: relative;

  &__gradient {
    position: absolute;
    top: 80px;
    width: 100%;
    height: 30px;
    background: linear-gradient(
      0deg,
      #fff 26.25%,
      rgba(255, 255, 255, 0) 137.99%
    );
  }

  &__button {
    width: 100%;
    margin-top: 25px;

    &--hidden {
      margin-top: 36px;

      .seo-description__icon {
        transform: rotate(180deg);
      }
    }

    @include media('>=tablet') {
      width: 295px;
    }
  }
}

.seo {
  &--hidden {
    height: 110px;
    overflow: hidden;
  }

  &__content {
    color: var(--ui-text-primary);

    :deep(h1) {
      margin-bottom: 24px;
      font-size: 16px;
      font-weight: 900;
      line-height: 33px;

      @include media('>tablet') {
        font-size: 18px;
      }

      @include media('>desktop-mini') {
        font-size: 28px;
      }
    }

    :deep(h2),
    :deep(h3) {
      margin-top: 24px;
      margin-bottom: 24px;
      font-size: 16px;
      font-weight: 900;
      line-height: 26px;

      @include media('>tablet') {
        font-size: 22px;
      }
    }

    :deep(h2) {
      margin: 15px 0;
    }

    :deep(p) {
      margin: 0 0 7px;
      font-size: 12px;
      font-weight: 500;
      line-height: 1.5;
    }

    :deep(ul),
    :deep(ol) {
      margin: 0 0 7px 25px;
      font-size: 12px;
      font-weight: 500;
      line-height: 1.7;
    }
  }

  &__content-title {
    margin-bottom: 25px;
    font-size: 16px;
    font-weight: 900;
    line-height: 26px;

    @include media('>tablet') {
      font-size: 18px;
    }

    @include media('>desktop-mini') {
      font-size: 28px;
    }
  }

  &__content-text {
    margin: 0;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
  }
}
</style>
